import * as React from "react"
import Lightbox from "react-images"

import Colors from "../../theme/colors"

const lightboxTheme = {
  container: {
    background: "rgba(255, 255, 255, 0.96)",
    width: "100%"
  },
  footer: {
    position: "absolute",
    top: 0,
    width: "100%",
    display: "flex",
    justifyContent: "center",
    fontSize: 19,
    color: "black"
  },
  footerCount: {
    color: Colors.darkGrey,
    fontWeight: 600
  },
  close: {
    zIndex: 1,
    fill: Colors.darkGrey
  },
  arrow: {
    fill: Colors.darkGrey
  }
}

interface Props {
  visible: boolean
  images: any
  onClose: () => void
}

interface State {
  currentImage: number
}

class Gallery extends React.PureComponent<Props, State> {
  state: State = { currentImage: 0 }

  navigatePrev = () => this.setState(({ currentImage }) => ({ currentImage: currentImage - 1 }))
  navigateNext = () => this.setState(({ currentImage }) => ({ currentImage: currentImage + 1 }))

  render() {
    const { images } = this.props
    const reducedImages = images.reduce((result: Array<{ src: string }>, image: any) => {
      return [...result, { src: image.url }]
    }, [])
    return (
      <Lightbox
        imageCountSeparator=" / "
        theme={lightboxTheme}
        images={reducedImages}
        closeButtonTitle="close"
        currentImage={this.state.currentImage}
        isOpen={this.props.visible}
        onClickPrev={this.navigatePrev}
        onClickNext={this.navigateNext}
        onClose={() => this.props.onClose()}
      />
    )
  }
}

export default Gallery
